import { css } from '@emotion/react'

import colors from './colors'
import fontSize from './fontSize'

const linkStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: ${fontSize.body01};
  text-decoration: none;
  color: ${colors.gray.$900};
`

const activeLinkStyle = {
  fontWeight: 700,
  color: `${colors.primary}`,
  cursor: 'default',
}

export { activeLinkStyle, linkStyle }
